import React, { useState, useRef, useImperativeHandle } from "react";
import PropTypes from "prop-types";
// import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { Label, InputText, Dropdown } from "../../../../components/Inputs";
import { MinusIconButton } from "../../../../components/Buttons";
import { getContentTypeIdFromType, CONTENT_IMAGE } from "../Utils";
import { isArray } from "lodash";
import { handleUploadError } from "../../../../components/Utils";

const ImageUploadForm = React.forwardRef(({ className, model, uploadUrl, multiple, expand }, ref) => {
  const imageRefs = useRef([]);
  let initialImages = [];
  try {
    initialImages = JSON.parse(model.body || "[]");
  } catch(err) {
    console.error("Error:", model, err);
  }
  const [images, setImages] = useState(initialImages);

  useImperativeHandle(ref, () => ({
    getModel: (noValidate) => {
      // console.log("ImageUploadForm.getModel()", images);
      const body = images.map((image, index) => {
        const imageModel = imageRefs.current[index].getModel(noValidate);
        // console.log("<< Result:", imageModel)
        return { ...image, style: imageModel.style || image.style };
      });
      return {
        id: model.id,
        content_type_id: getContentTypeIdFromType(CONTENT_IMAGE),
        body: JSON.stringify(body)
      };
    }
  }), [images, model]);

  const addImages = (event) => {
    // console.log("ImageUploadForm.addImages()", event);
    const response = JSON.parse(event.xhr.response);
    const newImages = isArray(response) ? response : [ response ];
    const items = newImages.map(item => ({
      image: "/data-api" + item.filePath,
      style: { width: "auto", height: "auto", maxWidth: "100%" }
    }));
    const updated = [ ...images ].concat(items);
    console.log("New Items:", items, updated);
    setImages(updated);
  };

  const removeImage = (currentIndex) => {
    setImages(images.filter((_, index) => index !== currentIndex));
  };

  console.log("ImageUploadForm.render()", images, { className, model, uploadUrl, multiple, expand });
  const markup = images.map((image, index) => {
    const menu = (
      <span className="w3-border w3-round pos-rel display-inline-block" style={{zIndex: 1}}>
        <MinusIconButton onClick={() => removeImage(index)}/>
      </span>
    );
    const menuStyle = { position: "absolute", right: "0px", top: "43px" };
    return (
      <div key={index} className={"clearfix pad-big-btm"/* expand ? "" : "pad-sm-top" */}>
        <ImageHolder
          ref={el => { imageRefs.current[index] = el; }}
          model={image}
          expand={expand}
          menu={<div style={menuStyle}>{menu}</div>}
        />
      </div>
    );
  });

  return (
    <div className={`${className} image-upload-form ${expand ? "" : "pad"}`}>
      <div className="clearfix">
        <div className="w3-right" style={{height: (images.length > 0) ? "0px" : "auto", zIndex: 1, position: "relative"}}>
          <FileUpload
            name="image"
            mode="basic"
            auto
            url={uploadUrl}
            multiple={multiple}
            accept="image/*"
            chooseLabel="Bild hochladen"
            onUpload={event => addImages(event)}
            onError={handleUploadError}
            disabled={!multiple && images.length === 1}
          />
        </div>
        {markup}
      </div>
    </div>
  );
});

ImageUploadForm.displayName = "ImageUploadForm";

ImageUploadForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.object,
  uploadUrl: PropTypes.string,
  multiple: PropTypes.bool,
  expand: PropTypes.bool,
};

ImageUploadForm.defaultProps = {
  className: "",
  model: { body: "[]" },
  uploadUrl: "/data-api/media/upload",
  multiple: true,
};

export default ImageUploadForm;

const ImageHolder = React.forwardRef(({ className, model: modelProp, menu, expand }, ref) => {
  const model = modelProp || {};
  const style = model.style || {};
  const [width, setWidth] = useState(expand ? "100%" : (style.width || "auto"));
  const [align, setAlign] = useState(style.align || "left");

  useImperativeHandle(ref, () => ({
    getModel: (noValidate) => {
      const modelStyle = model.style || {};
      const computedStyle = { ...modelStyle, width, align };
      if (expand) { computedStyle.width = "100%"; }
      // console.log("ImageHolder.getModel() style", computedStyle);
      return { ...model, style: computedStyle };
    }
  }), [width, align, model, expand]);

  const AlignOptions = [
    { label: "Links", value: "left" },
    { label: "Zentriert", value: "center" },
    { label: "Rechts", value: "right" }
  ];
  console.log("ImageHolder.render()", model);
  const widthForm = expand ? null : (
    <div style={{width: "400px"}}>
      <div className="w3-row neg-margin-lr pad-btm">
        <div className="w3-col s2 pad-lr pad-top">
          <Label>{`Breite`}</Label>
        </div>
        <div className="w3-col s4 pad-lr">
          <InputText className="w3-block w3-border" value={width} small
            onChange={(event) => setWidth(event.target.value)}/>
        </div>
        <div className="w3-col s2 pad-lr pad-top">
          <Label>{`Position `}</Label>
        </div>
        <div className="w3-col s4 pad-lr">
          <Dropdown
            className="w3-block w3-border"
            value={align}
            options={AlignOptions}
            onChange={(event) => setAlign(event.value)}
            showClear
          />
        </div>
      </div>
    </div>
  );
  return (
    <div className={`image-holder ${className} clearfix`}>
      <div className="clearfix">
        {menu}{widthForm}
      </div>
      <div className="clearfix" style={{ textAlign: align }}>
        <img
          src={model.image.replace("/api/", "/data-api/")}
          style={{ ...model.style, width }}
          alt={"Bild"}
        />
      </div>
    </div>
  );
});

ImageHolder.displayName = "ImageHolder";

ImageHolder.propTypes = {
  className: PropTypes.string,
  model: PropTypes.object,
  menu: PropTypes.node,
  expand: PropTypes.bool,
};

ImageHolder.defaultProps = {
  className: "",
  model: { image: "", style: {} },
};
